export default function convertToNumber(text) {
    if (typeof text === "number") return text;
    const number = Number(text.replace(/,/g, ""));
    return number;
}
